/**
 * OIMS v2 - Sidebar navigation
 * Expand/collapse + tab switching via data-tab-target
 */

let sidebarEl = null;

export function initSidebar() {
  sidebarEl = document.getElementById('sidebar');
  if (!sidebarEl) return;

  // Restore collapsed state from localStorage
  const collapsed = localStorage.getItem('oims-sidebar-collapsed') === 'true';
  if (collapsed) {
    sidebarEl.classList.add('sidebar-collapsed');
  }

  // Toggle button
  const toggleBtn = sidebarEl.querySelector('.sidebar-toggle');
  if (toggleBtn) {
    toggleBtn.addEventListener('click', toggleSidebar);
  }

  // Tab switching via sidebar nav links
  const navLinks = sidebarEl.querySelectorAll('.nav-link[data-tab-target]');
  navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = link.getAttribute('data-tab-target');
      switchTab(target, navLinks);
    });
  });
}

function toggleSidebar() {
  if (!sidebarEl) return;
  sidebarEl.classList.toggle('sidebar-collapsed');
  const isCollapsed = sidebarEl.classList.contains('sidebar-collapsed');
  localStorage.setItem('oims-sidebar-collapsed', isCollapsed);
}

function switchTab(tabId, navLinks) {
  // Update active state on sidebar nav links
  navLinks.forEach(l => l.classList.remove('active'));
  const activeLink = sidebarEl.querySelector(`.nav-link[data-tab-target="${tabId}"]`);
  if (activeLink) activeLink.classList.add('active');

  // Switch tab content panes
  const allPanes = document.querySelectorAll('.tab-content > .tab-pane');
  allPanes.forEach(pane => {
    pane.classList.remove('show', 'active');
  });

  const targetPane = document.getElementById(tabId);
  if (targetPane) {
    targetPane.classList.add('show', 'active');
  }

  // Dispatch a custom event so other modules can react to tab changes
  document.dispatchEvent(new CustomEvent('oims:tab-change', { detail: { tab: tabId } }));
}

/**
 * Remove a tab from the sidebar by its data-tab-target value
 */
export function removeSidebarTab(tabId) {
  if (!sidebarEl) return;
  const link = sidebarEl.querySelector(`.nav-link[data-tab-target="${tabId}"]`);
  if (link) link.remove();
}

/**
 * Activate the first visible sidebar tab
 */
export function activateFirstTab() {
  if (!sidebarEl) return;
  const firstLink = sidebarEl.querySelector('.nav-link[data-tab-target]');
  if (firstLink) {
    firstLink.click();
  }
}

/**
 * Keyboard shortcut: switch to tab by index (1-based)
 */
export function switchTabByIndex(index) {
  if (!sidebarEl) return;
  const links = sidebarEl.querySelectorAll('.nav-link[data-tab-target]');
  if (links[index - 1]) {
    links[index - 1].click();
  }
}
